module.exports = __webpack_public_path__ + "static/content-0e5f951b0fa84b6f0f7eef861f3c9669.jpg";